<!-- Header -->
<h1 mat-dialog-title>{{ 'assign' | translate }}</h1>

<!-- Content -->
<div mat-dialog-content>
  <form [formGroup]="form" fxLayout="column">

    <mat-form-field appearance="standard">
      <mat-label>{{ 'assignto' | translate }}</mat-label>
      <mat-select formControlName="user">
        <mat-option [value]="-1">
          Niet toegewezen
        </mat-option>
        <mat-option *ngFor="let user of userService.user$ | async" [value]="user._id">
          {{ user.fullName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <mat-form-field appearance="standard">
      <mat-label>{{ 'status' | translate }}</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let status of statuses" [value]="status._id">
          {{ status.displayName }}
          <span *ngIf="status._id === element.status">({{ 'statuscurrent' | translate: 'lowerCase' }})</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard">
      <mat-label>{{ 'commentOptional' | translate }}</mat-label>
      <textarea matInput 
        formControlName="comment"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="3">
      </textarea>
    </mat-form-field>

  </form>
</div>

<!-- Actions -->
<div mat-dialog-actions align="end">

  <button mat-button tabindex="-1" (click)="dialogRef.close()">
    {{ 'cancel' | translate }}
  </button>
  
  <button mat-flat-button (click)="submit()" tabindex="-1" [color]="'primary'">
    {{ 'assign' | translate: 'plural' }}
  </button>

</div>
